import { Property } from '@/types';
import clsx from 'clsx';
// import { ProgressBlock } from './progress-block';

interface BedroomComparisionLineItemProps {
  value: number | string;
  comparisionResult: number;
  masterProperty?: Property;
  property: Property;
}

function getRooms(property: Property) {
  return Array.prototype.concat.apply([], property.rooms).map((r) => ({
    length: r.length,
    width: r.width,
    description: r.description,
    isRoom:
      [
        'Prim Bdrm',
        '2nd Br',
        '3rd Br',
        'Br',
        'Master',
        '4th Br',
        '5th Br',
      ].indexOf(r.description) !== -1,
    sizeInMtr: Number(
      Math.round(
        (isNaN(Number(r.length)) ? 0 : Number(r.length)) *
          (isNaN(Number(r.width)) ? 0 : Number(r.width)) *
          100
      ) / 100
    ),
  }));
}

function getBedrooms(property: Property) {
  const rooms = getRooms(property);
  const bedrooms = rooms.filter((x) => x.isRoom);

  if (!isNaN(Number(property.beds))) {
    while (bedrooms.length < Number(property.beds)) {
      bedrooms.push({
        length: 0,
        width: 0,
        description: 'Bedroom',
        isRoom: true,
        sizeInMtr: 0,
      });
    }
  }

  return bedrooms;
}

export const BedroomComparisionLineItem: React.FC<
  BedroomComparisionLineItemProps
> = (props) => {
  let diff;

  const bedrooms = getBedrooms(props.property);

  if (
    props.masterProperty &&
    props.masterProperty.propertyNumber !== props.property.propertyNumber
  ) {
    const diffCount =
      Number(props.property.beds) - Number(props.masterProperty.beds);

    let diffSize = 0;

    // const isAllRoomHaveSize = bedrooms.every((x) => x.sizeInMtr > 0);
    const masterPropertyBedrooms = getBedrooms(props.masterProperty);

    if (
      masterPropertyBedrooms.every((x) => x.sizeInMtr > 0) &&
      bedrooms.every((x) => x.sizeInMtr > 0)
    ) {
      const size = bedrooms.reduce((p, c) => p + c.sizeInMtr, 0);
      const masterSize = masterPropertyBedrooms.reduce(
        (p, c) => p + c.sizeInMtr,
        0
      );

      diffSize = size - masterSize;
    }

    diff = (
      <>
        {' '}
        <span className={diffCount > 0 ? 'text-green-500' : 'text-red-500'}>
          {diffCount > 0 && `+ ${diffCount} Room`}
        </span>{' '}
        {diffSize !== 0 && (
          <span className={diffSize > 0 ? 'text-green-500' : 'text-red-500'}>
            {diffSize !== 0 &&
              `${Math.round(diffSize * 10.7639 * 100) / 100} sqft `}
          </span>
        )}
      </>
    );
  }

  return (
    <div className="relative">
      <div className="px-2">
        {props.value}&nbsp;{diff}
      </div>
      <div className="px-2 pb-1">
        {bedrooms.map((bedroom, index) => (
          <div key={index} className="flex flex-row items-center">
            <div
              className={clsx(
                'h-full mt-1',
                bedroom.sizeInMtr === 0 ? 'bg-red-200' : 'bg-primary-200'
              )}
              style={{
                width: bedroom.sizeInMtr === 0 ? '5%' : `${bedroom.sizeInMtr}%`,
                height: 20,
              }}
            />
            {bedroom.sizeInMtr > 0 && (
              <div className="text-xs text-gray-600 ml-1">
                {Math.round(bedroom.sizeInMtr * 10.7639 * 100) / 100} sqft
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
